import React from 'react';
import './navbar.scss';
import { withRouter } from "react-router-dom";
import { translate } from "react-translate";
import { Navbar as BTNavbar, Nav } from 'react-bootstrap';
import logo from '../../images/logo.png';
import flag_ka from '../../images/flag_ka.png';
import flag_en from '../../images/flag_en.png';
import flag_ru from '../../images/flag_ru.png';

class Navbar extends React.Component {

  render() {
    return (
      <div className={ this.props.congressNavigation ? 'component myNavbar congress' : 'component myNavbar' }>
        <BTNavbar collapseOnSelect expand="lg">
          <BTNavbar.Brand href="/">
            <img className="logo" src={logo} alt="logo" />
          </BTNavbar.Brand>
          <BTNavbar.Toggle aria-controls="responsive-navbar-nav" id="navbar_toggler_btn" />
          <BTNavbar.Collapse id="responsive-navbar-nav">
            <Nav className="mr-auto capsFont">
              <Nav.Link href="/" className={ this.props.match.url === '/' ? 'active' : '' }>{ this.props.t('home') }</Nav.Link>
              <Nav.Link href="/congress" className={ this.props.match.url === '/congress' ? 'congress active' : 'congress' }>{ this.props.t('congress') }</Nav.Link>
              <Nav.Link href="/contact" className={ this.props.match.url === '/contact' ? 'active' : '' }>{ this.props.t('contact') }</Nav.Link>
              <a onClick={() => document.getElementById('navbar_toggler_btn').click()} className="nav-link mobile" href="#president">{ this.props.t('congress_president') }</a>
              <a onClick={() => document.getElementById('navbar_toggler_btn').click()} className="nav-link mobile" href="#location">{ this.props.t('congress_location') }</a>
              <a onClick={() => document.getElementById('navbar_toggler_btn').click()} className="nav-link mobile" href="#speakers">{ this.props.t('congress_speakers') }</a>
              <a onClick={() => document.getElementById('navbar_toggler_btn').click()} className="nav-link mobile" href="#schedule">{ this.props.t('congress_schedule') }</a>
              <a onClick={() => document.getElementById('navbar_toggler_btn').click()} className="nav-link mobile" href="#sponsor">{ this.props.t('congress_sponsor') }</a>
              <a onClick={() => document.getElementById('navbar_toggler_btn').click()} className="nav-link mobile" href="#speaker">{ this.props.t('congress_speaker') }</a>
              <a onClick={() => document.getElementById('navbar_toggler_btn').click()} className="nav-link mobile" href="#delegate">{ this.props.t('congress_delegate') }</a>
              <a onClick={() => document.getElementById('navbar_toggler_btn').click()} className="nav-link mobile register" href="/register">{ this.props.t('congress_registration') }</a>
            </Nav>
            <Nav>
              <Nav.Link href="#" className={ (this.props.commonProps.lang === 'ka' ? 'flag activeLang' : 'flag') } onClick={() => this.props.commonProps.switchLanguage('ka')}>
                <img src={flag_ka} alt="georgian flag" />
                <span className="capsFont">&nbsp;&nbsp;{ this.props.t('georgian') }</span>
              </Nav.Link>
              <Nav.Link href="#" className={ (this.props.commonProps.lang === 'en' ? 'flag activeLang' : 'flag') } onClick={() => this.props.commonProps.switchLanguage('en')}>
                <img src={flag_en} alt="us flag" />
                <span className="capsFont">&nbsp;&nbsp;{ this.props.t('english') }</span>
              </Nav.Link>
              <Nav.Link href="#" className={ (this.props.commonProps.lang === 'ru' ? 'flag activeLang' : 'flag') } onClick={() => this.props.commonProps.switchLanguage('ru')}>
                <img src={flag_ru} alt="russian flag" />
                <span className="capsFont">&nbsp;&nbsp;{ this.props.t('russian') }</span>
              </Nav.Link>
            </Nav>
          </BTNavbar.Collapse>
        </BTNavbar>

        <div className="congress_navigation capsFont">
          <a href="#president">{ this.props.t('congress_president') }</a>
          <a href="#location">{ this.props.t('congress_location') }</a>
          <a href="#speakers">{ this.props.t('congress_speakers') }</a>
          <a href="#schedule">{ this.props.t('congress_schedule') }</a>
          <a href="#sponsor">{ this.props.t('congress_sponsor') }</a>
          <a href="#speaker">{ this.props.t('congress_speaker') }</a>
          <a href="#delegate">{ this.props.t('congress_delegate') }</a>
          {/* <a href="/register" className="register">{ this.props.t('congress_registration') }</a> */}
        </div>
      </div>
    );
  }

}

export default translate('Navbar')(withRouter(Navbar));
